<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function syncThumbnailHeight() {
  const thumbs = document.querySelector('.productView-thumbnail-wrapper');
  const mainImage = document.querySelector('.productView-image-wrapper');

  if (!thumbs || !mainImage) return;

  // Only apply on desktop
  if (window.innerWidth < 1280) {
    thumbs.style.removeProperty('--main-gallery-height');
    thumbs.style.height = '';

    const slickList = thumbs.querySelector('.slick-list');
    if (slickList) slickList.style.height = '';

    return;
  }

  const height = mainImage.offsetHeight;

  thumbs.style.setProperty('--main-gallery-height', `${height}px`);

  const slickList = thumbs.querySelector('.slick-list');
  if (slickList) {
    slickList.style.height = `${height - 70}px`;
  }
}

window.addEventListener('load', syncThumbnailHeight);
window.addEventListener('resize', syncThumbnailHeight);
document.addEventListener('shopify:section:load', syncThumbnailHeight);